// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__LocationsAndBuildingsPage__accordionHeaderContainer{align-items:center;display:flex}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-quoteandbind-bop-react/pages/LocationsAndBuildings/LocationsAndBuildingsPage.module.scss"],"names":[],"mappings":"AAAA,0DAEI,kBAAA,CADA,YACA","sourcesContent":[".accordionHeaderContainer {\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accordionHeaderContainer": "app__LocationsAndBuildingsPage__accordionHeaderContainer"
};
export default ___CSS_LOADER_EXPORT___;
